export const LOADING_INITIALIZE = 'LOADING_INITIALIZE';
export const loadingInitialize = (howManyStages) => ({ type: LOADING_INITIALIZE, payload: howManyStages });

export const LOADING_NEXT_STAGE = 'LOADING_NEXT_STAGE';
export const loadingNextStage = () => ({ type: LOADING_NEXT_STAGE });

export const LOADING_COMPLETED = 'LOADING_COMPLETED';
export const loadingCompleted = () => ({ type: LOADING_COMPLETED });
